// src/redux/reducers/logReducer.js
const initialState = {
  logs: [],
  totalPages: 1,
};

export default function logReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_LOGS_SUCCESS':
      return {
        ...state,
        logs: action.payload.logs,
        totalPages: action.payload.totalPages,
      };
    default:
      return state;
  }
}
